import { render, staticRenderFns } from "./TableInvoice.vue?vue&type=template&id=6cda4abc"
import script from "./TableInvoice.vue?vue&type=script&lang=js"
export * from "./TableInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports